import React, { useMemo } from 'react';

const TCSResumePreview = ({ componentRef, resumeData = {} }) => {
  const {
    full_name = 'Tamilarasan R',
    phone = '9600535931',
    email = 'tamildevopscloud@gmail.com',
    linkedin = '',
    location = 'Bangalore',
    former_tcs_emp = 'No',
    emp_id = 'NO',
    interview_availability = [
      { date: '3.11.2025', time_slot: '3:00 PM' },
      { date: '4.11.2025', time_slot: '3:00 PM' },
      { date: '5.11.2025', time_slot: '3:00 PM' }
    ],
    skills_matrix = [
      { skill_name: 'Devops', years_experience: '5.2 Years' },
      { skill_name: 'AWS', years_experience: '5 Years' },
      { skill_name: 'Terraform', years_experience: '4 Years' }
    ],
    supplier_comments = 'We have screened this profile. He have good Experience in Devops Engineer with 5.2 years.',
    supplier_note = 'NOTE: if any career gaps or education gaps. Must have to mention here with the reason. Why they have career or education gap'
  } = resumeData || {};

  // Get all dynamic sections (same logic as ResumeEditor.getDynamicSections)
  const dynamicSections = useMemo(() => {
    if (!resumeData) return [];
    
    const fieldsAlreadyDisplayed = [
      "full_name", "name", "email", "phone", "location", "address", "job_title",
      "linkedin", "github", "portfolio", "hackerrank", "leetcode", "whatsapp", "websites",
      "personal_info", "personalinfo", "contact_info", "contactinfo", "contact",
      "professional_summary", "summary", "resume_summary", "tagline_primary", "tagline_secondary",
      "summary_intro", "looking_to_items", "expertise_paragraph", "collaboration_paragraph",
      "call_to_action_phone", "call_to_action_email", "key_bullet_sections",
      "relevant_experience", "work_experience", "experience",
      "skills", "key_skills", "technical_skills", "professional_skills", "structured_skills",
      "soft_skills", "programming_skills",
      "education",
      "certifications",
      "languages_data", "isTemplate", "isUploadedResume", "shouldShowUserData",
      "template_id", "templateId", "_sections_map", "dynamic_sections",
      "projects",
      "achievements", "awards",
      "interview_availability", "skills_matrix", "supplier_comments", "supplier_note",
      "former_tcs_emp", "emp_id",
      "isTemplate", "isUploadedResume", "shouldShowUserData", "template_name",
      "template_id", "profile_image_url", "references_note",
      "additional_sections", "work_experience", "highlights", "duties",
      "languages", "publications", "volunteer_work", "additional_info", "references"
    ];

    const normalize = (str) => str.toLowerCase().replace(/[_\s-]/g, "");
    const normalizedDisplayed = fieldsAlreadyDisplayed.map(normalize);
    
    const hasData = (value) => {
      if (!value) return false;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === "string") return value.trim().length > 0;
      if (typeof value === "object") return Object.keys(value).length > 0;
      return true;
    };

    const sections = [];
    Object.keys(resumeData).forEach((key) => {
      const normalizedKey = normalize(key);
      if (normalizedDisplayed.includes(normalizedKey)) return;
      if (hasData(resumeData[key])) {
        const label = key
          .split(/[_\s-]/)
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        sections.push({ id: key, label: label, data: resumeData[key] });
      }
    });
    return sections;
  }, [resumeData]);

  // Generic renderer for dynamic sections
  const renderDynamicSection = (section) => {
    const { id, label, data } = section;
    
    // ARRAY handling
    if (Array.isArray(data)) {
      return (
        <div key={id} className="tcs-indented-section">
          <div className="tcs-section-title">{label}</div>
          <div className="tcs-availability-blocks">
            {data.map((item, index) => (
              <div key={index} className="tcs-availability-row">
                <div className="tcs-availability-block">
                  {typeof item === 'string' ? item : JSON.stringify(item)}
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }
    
    // STRING handling
    if (typeof data === "string") {
      return (
        <div key={id} className="tcs-indented-section">
          <div className="tcs-section-title">{label}</div>
          <div className="tcs-availability-blocks">
            <div className="tcs-availability-row">
              <div className="tcs-availability-block">{data}</div>
            </div>
          </div>
        </div>
      );
    }
    
    // OBJECT handling
    if (typeof data === "object" && data !== null) {
      return (
        <div key={id} className="tcs-indented-section">
          <div className="tcs-section-title">{label}</div>
          <div className="tcs-availability-blocks">
            {Object.keys(data).map((key) => (
              <div key={key} className="tcs-availability-row">
                <div className="tcs-availability-block" style={{ fontWeight: 'bold' }}>
                  {key.split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ")}:
                </div>
                <div className="tcs-availability-block">
                  {typeof data[key] === 'object' ? JSON.stringify(data[key]) : String(data[key] || '')}
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    }
    
    return null;
  };

  return (
    <div id="section-to-print" className="tcs-resume-preview" ref={componentRef}>
      <style>{`
        .tcs-resume-preview {
          width: 210mm;
          max-width: 210mm;
          min-height: 297mm;
          background: white;
          font-family: Arial, Helvetica, sans-serif;
          padding: 20px;
          box-sizing: border-box;
          overflow-wrap: break-word;
          word-wrap: break-word;
          overflow-x: hidden;
        }

        .tcs-resume-preview * {
          max-width: 100%;
          box-sizing: border-box;
          overflow-wrap: break-word;
          word-wrap: break-word;
        }

        .tcs-section {
          margin-bottom: 25px;
        }

        .tcs-candidate-section {
          width: 100%;
          max-width: 100%;
          margin-bottom: 25px;
          box-sizing: border-box;
          overflow: hidden;
        }

        .tcs-indented-section {
          width: calc(100% - 40px);
          max-width: calc(100% - 40px);
          margin-left: 40px;
          margin-bottom: 25px;
          box-sizing: border-box;
          overflow: hidden;
        }

        /* Candidate Details Header */
        .tcs-candidate-header {
          width: 100%;
          max-width: 100%;
          padding: 12px 15px;
          background: #A8CAE9;
          border: 2px solid #ffffff;
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          color: #000000;
          margin: 0 0 2px 0;
          box-sizing: border-box;
          overflow-wrap: break-word;
          word-wrap: break-word;
        }

        /* Candidate Details - Separate Blocks */
        .tcs-candidate-blocks {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .tcs-candidate-row {
          display: flex;
          width: 100%;
          max-width: 100%;
          margin: 0 0 2px 0;
          padding: 0;
          gap: 2px;
          box-sizing: border-box;
        }

        .tcs-candidate-row:last-child {
          margin-bottom: 0;
        }

        .tcs-candidate-label-block {
          padding: 10px 15px;
          background: #A8CAE9;
          color: #000000;
          font-weight: bold;
          font-size: 13px;
          width: 40%;
          min-width: 0;
          max-width: 40%;
          border: 2px solid #ffffff;
          box-sizing: border-box;
          overflow-wrap: break-word;
          word-wrap: break-word;
          word-break: break-word;
        }

        .tcs-candidate-value-block {
          padding: 10px 15px;
          background: #A8CAE9;
          color: #000000;
          font-size: 13px;
          flex: 1;
          min-width: 0;
          max-width: 100%;
          border: 2px solid #ffffff;
          box-sizing: border-box;
          overflow-wrap: break-word;
          word-wrap: break-word;
          word-break: break-word;
          overflow: hidden;
        }

        /* Interview Availability - Separate Blocks */
        .tcs-availability-blocks {
          width: 100%;
          margin: 0;
          margin-top: 0;
          padding: 0;
        }

        .tcs-availability-header-row {
          display: flex;
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .tcs-availability-header-row {
          display: flex;
          width: 100%;
          margin: 0 0 2px 0;
          padding: 0;
          gap: 2px;
        }

        .tcs-availability-header-block {
          padding: 12px;
          background: #A8CAE9;
          color: #000000;
          font-weight: bold;
          font-size: 14px;
          flex: 1;
          min-width: 0;
          max-width: 100%;
          border: 2px solid #ffffff;
          box-sizing: border-box;
          overflow-wrap: break-word;
          word-wrap: break-word;
          word-break: break-word;
        }

        .tcs-availability-row {
          display: flex;
          width: 100%;
          max-width: 100%;
          margin: 0 0 2px 0;
          padding: 0;
          gap: 2px;
          box-sizing: border-box;
        }

        .tcs-availability-block {
          padding: 10px 12px;
          background: #A8CAE9;
          color: #000000;
          font-size: 13px;
          flex: 1;
          min-width: 0;
          max-width: 100%;
          border: 2px solid #ffffff;
          box-sizing: border-box;
          overflow-wrap: break-word;
          word-wrap: break-word;
          word-break: break-word;
          overflow: hidden;
        }

        .tcs-availability-row:last-child {
          margin-bottom: 0;
        }

        .tcs-section-title {
          text-align: center;
          font-weight: bold;
          font-size: 16px;
          margin: 0 0 2px 0;
          padding: 12px 15px;
          background: #A8CAE9;
          color: #000000;
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
          border: 2px solid #ffffff;
          overflow-wrap: break-word;
          word-wrap: break-word;
        }

        /* Skills Matrix - Separate Blocks */
        .tcs-skills-blocks {
          width: 100%;
          margin: 0;
          margin-top: 0;
          padding: 0;
        }

        .tcs-skills-header-row {
          display: flex;
          width: 100%;
          margin: 0 0 2px 0;
          padding: 0;
          gap: 2px;
        }

        .tcs-skills-header-block {
          padding: 12px;
          background: #A8CAE9;
          color: #000000;
          font-weight: bold;
          font-size: 14px;
          flex: 1;
          min-width: 0;
          max-width: 100%;
          border: 2px solid #ffffff;
          box-sizing: border-box;
          overflow-wrap: break-word;
          word-wrap: break-word;
          word-break: break-word;
        }

        .tcs-skills-row {
          display: flex;
          width: 100%;
          max-width: 100%;
          margin: 0 0 2px 0;
          padding: 0;
          gap: 2px;
          box-sizing: border-box;
        }

        .tcs-skills-block {
          padding: 10px 12px;
          background: #A8CAE9;
          color: #000000;
          font-size: 13px;
          flex: 1;
          min-width: 0;
          max-width: 100%;
          border: 2px solid #ffffff;
          box-sizing: border-box;
          overflow-wrap: break-word;
          word-wrap: break-word;
          word-break: break-word;
          overflow: hidden;
        }

        .tcs-skills-block:first-child {
          font-weight: normal;
        }

        .tcs-skills-block:last-child {
          font-weight: bold;
        }

        .tcs-skills-row:last-child {
          margin-bottom: 0;
        }

        /* Supplier Screening Comments */
        .tcs-comments-section {
          background: transparent;
          padding: 0;
          border: none;
          display: block;
        }

        .tcs-comments-table {
          width: 100%;
          max-width: 100%;
          border-collapse: separate;
          border-spacing: 2px;
          border: none;
          table-layout: fixed;
          box-sizing: border-box;
        }

        .tcs-comments-table td {
          padding: 70px 15px;
          border: 2px solid #ffffff;
          font-size: 13px;
          background: #A8CAE9;
          color: #000000;
          overflow-wrap: break-word;
          word-wrap: break-word;
          word-break: break-word;
          overflow: hidden;
          box-sizing: border-box;
        }

        .tcs-comments-table td:first-child {
          width: 30%;
          max-width: 30%;
          font-weight: bold;
        }

        .tcs-comments-table td:last-child {
          width: 70%;
          max-width: 70%;
          background: #A8CAE9;
          font-weight: normal;
          color: #000000;
        }

        @media print {
          @page {
            size: A4;
            margin: 0;
            background: white;
          }
          
          html, body {
            background: white !important;
            margin: 0;
            padding: 0;
          }
          
          #section-to-print {
            background: white !important;
          }
          
          .tcs-resume-preview {
            width: 210mm !important;
            max-width: 210mm !important;
            min-height: auto;
            padding: 15mm;
            box-shadow: none;
            margin: 0;
            background: white !important;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      `}</style>

      {/* Candidate Details Section - Full Width Block */}
      <div className="tcs-candidate-section">
        <div className="tcs-candidate-header">CANDIDATE DETAILS</div>
        <div className="tcs-candidate-blocks">
          <div className="tcs-candidate-row">
            <div className="tcs-candidate-label-block">Name:</div>
            <div className="tcs-candidate-value-block">{full_name}</div>
          </div>
          <div className="tcs-candidate-row">
            <div className="tcs-candidate-label-block">Contact Number:</div>
            <div className="tcs-candidate-value-block">{phone}</div>
          </div>
          <div className="tcs-candidate-row">
            <div className="tcs-candidate-label-block">Email ID:</div>
            <div className="tcs-candidate-value-block">{email}</div>
          </div>
          <div className="tcs-candidate-row">
            <div className="tcs-candidate-label-block">LinkedIn profile link</div>
            <div className="tcs-candidate-value-block">{linkedin || ''}</div>
          </div>
          <div className="tcs-candidate-row">
            <div className="tcs-candidate-label-block">Current Location</div>
            <div className="tcs-candidate-value-block">{location}</div>
          </div>
          <div className="tcs-candidate-row">
            <div className="tcs-candidate-label-block">Former TCS EMP/ BA:</div>
            <div className="tcs-candidate-value-block">{former_tcs_emp}</div>
          </div>
          <div className="tcs-candidate-row">
            <div className="tcs-candidate-label-block">EMP ID (Former TCS):</div>
            <div className="tcs-candidate-value-block">{emp_id}</div>
          </div>
        </div>
      </div>

      {/* Interview Availability Section - Indented */}
      <div className="tcs-indented-section">
        <div className="tcs-section-title">Interview Availability</div>
        <div className="tcs-availability-blocks">
          <div className="tcs-availability-header-row">
            <div className="tcs-availability-header-block">Date</div>
            <div className="tcs-availability-header-block">Time Slot</div>
          </div>
          {(interview_availability || []).map((item, index) => (
            <div key={index} className="tcs-availability-row">
              <div className="tcs-availability-block">{item.date || ''}</div>
              <div className="tcs-availability-block">{item.time_slot || ''}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Skills Matrix Section - Indented - Limited to 3 skills max */}
      <div className="tcs-indented-section">
        <div className="tcs-section-title">Skills Matrix</div>
        <div className="tcs-skills-blocks">
          <div className="tcs-skills-header-row">
            <div className="tcs-skills-header-block">Skill Name</div>
            <div className="tcs-skills-header-block">Years of Experience</div>
          </div>
          {((skills_matrix || []).slice(0, 3)).map((item, index) => (
            <div key={index} className="tcs-skills-row">
              <div className="tcs-skills-block">{item.skill_name || ''}</div>
              <div className="tcs-skills-block">{item.years_experience || ''}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Work Experience Section - Indented */}
      {((resumeData.relevant_experience || resumeData.experience || []).length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">Work Experience</div>
          <div className="tcs-availability-blocks">
            {(resumeData.relevant_experience || resumeData.experience || []).map((exp, index) => (
              <div key={index} style={{ marginBottom: '15px' }}>
                <div className="tcs-availability-row">
                  <div className="tcs-availability-block" style={{ fontWeight: 'bold' }}>
                    {exp.position || ''}
                  </div>
                  <div className="tcs-availability-block">
                    {exp.company || ''}
                  </div>
                </div>
                {(exp.start_date || exp.end_date) && (
                  <div className="tcs-availability-row">
                    <div className="tcs-availability-block">
                      {exp.start_date || ''} - {exp.end_date || 'Present'}
                    </div>
                    <div className="tcs-availability-block">
                      {exp.location || ''}
                    </div>
                  </div>
                )}
                {exp.description_points && exp.description_points.length > 0 && (
                  <div style={{ padding: '10px 12px', background: '#A8CAE9', border: '2px solid #ffffff', marginTop: '2px' }}>
                    {exp.description_points.map((point, pIndex) => (
                      <p key={pIndex} style={{ margin: '0 0 4px 0', fontSize: '13px' }}>• {point}</p>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Education Section - Indented */}
      {(resumeData.education && resumeData.education.length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">Education</div>
          <div className="tcs-availability-blocks">
            {resumeData.education.map((edu, index) => (
              <div key={index} style={{ marginBottom: '15px' }}>
                <div className="tcs-availability-row">
                  <div className="tcs-availability-block" style={{ fontWeight: 'bold' }}>
                    {edu.degree || ''}
                  </div>
                  <div className="tcs-availability-block">
                    {edu.institution || ''}
                  </div>
                </div>
                {(edu.start_date || edu.end_date || edu.start_year || edu.end_year) && (
                  <div className="tcs-availability-row">
                    <div className="tcs-availability-block">
                      {edu.start_date || edu.start_year || ''} - {edu.end_date || edu.end_year || edu.graduation_date || ''}
                    </div>
                    <div className="tcs-availability-block">
                      {edu.location || ''}
                    </div>
                  </div>
                )}
                {edu.cgpa && (
                  <div className="tcs-availability-row">
                    <div className="tcs-availability-block">
                      CGPA: {edu.cgpa}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Projects Section - Indented */}
      {(resumeData.projects && resumeData.projects.length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">Projects</div>
          <div className="tcs-availability-blocks">
            {resumeData.projects.map((proj, index) => (
              <div key={index} style={{ marginBottom: '15px' }}>
                <div className="tcs-availability-row">
                  <div className="tcs-availability-block" style={{ fontWeight: 'bold' }}>
                    {proj.title || proj.name || ''}
                  </div>
                  <div className="tcs-availability-block">
                    {proj.year || ''}
                  </div>
                </div>
                {proj.description && (
                  <div style={{ padding: '10px 12px', background: '#A8CAE9', border: '2px solid #ffffff', marginTop: '2px' }}>
                    <p style={{ margin: 0, fontSize: '13px' }}>{proj.description}</p>
                  </div>
                )}
                {proj.technologies && (
                  <div className="tcs-availability-row">
                    <div className="tcs-availability-block">
                      Technologies: {Array.isArray(proj.technologies) ? proj.technologies.join(', ') : proj.technologies}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Achievements Section - Indented */}
      {(resumeData.achievements && resumeData.achievements.length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">Achievements</div>
          <div className="tcs-availability-blocks">
            {resumeData.achievements.map((achievement, index) => (
              <div key={index} className="tcs-availability-row">
                <div className="tcs-availability-block">• {achievement}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Certifications Section - Indented */}
      {(resumeData.certifications && resumeData.certifications.length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">Certifications</div>
          <div className="tcs-availability-blocks">
            {resumeData.certifications.map((cert, index) => (
              <div key={index} className="tcs-availability-row">
                <div className="tcs-availability-block">
                  {typeof cert === 'string' ? cert : cert.name || ''}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Languages Section - Indented */}
      {(resumeData.languages && resumeData.languages.length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">Languages</div>
          <div className="tcs-availability-blocks">
            {resumeData.languages.map((lang, index) => (
              <div key={index} className="tcs-availability-row">
                <div className="tcs-availability-block">
                  {typeof lang === 'string' ? lang : (lang.language || lang.name || '')}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Publications Section - Indented */}
      {(resumeData.publications && resumeData.publications.length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">Publications</div>
          <div className="tcs-availability-blocks">
            {resumeData.publications.map((pub, index) => (
              <div key={index} className="tcs-availability-row">
                <div className="tcs-availability-block">• {pub}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Volunteer Work Section - Indented */}
      {(resumeData.volunteer_work && resumeData.volunteer_work.length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">Volunteer Work</div>
          <div className="tcs-availability-blocks">
            {resumeData.volunteer_work.map((vol, index) => (
              <div key={index} className="tcs-availability-row">
                <div className="tcs-availability-block">• {vol}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Additional Information Section - Indented */}
      {(resumeData.additional_info && resumeData.additional_info.length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">Additional Information</div>
          <div className="tcs-availability-blocks">
            {resumeData.additional_info.map((info, index) => (
              <div key={index} className="tcs-availability-row">
                <div className="tcs-availability-block">• {info}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* References Section - Indented */}
      {(resumeData.references && resumeData.references.length > 0) && (
        <div className="tcs-indented-section">
          <div className="tcs-section-title">References</div>
          <div className="tcs-availability-blocks">
            {resumeData.references.map((ref, index) => (
              <div key={index} style={{ marginBottom: '15px' }}>
                <div className="tcs-availability-row">
                  <div className="tcs-availability-block" style={{ fontWeight: 'bold' }}>
                    {ref.name || ''}
                  </div>
                  <div className="tcs-availability-block">
                    {ref.title || ''}
                  </div>
                </div>
                {ref.company && (
                  <div className="tcs-availability-row">
                    <div className="tcs-availability-block">{ref.company}</div>
                  </div>
                )}
                {(ref.email || ref.phone) && (
                  <div className="tcs-availability-row">
                    <div className="tcs-availability-block">{ref.email || ''}</div>
                    <div className="tcs-availability-block">{ref.phone || ''}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Generic Dynamic Sections - Automatically render all sections that appear in form */}
      {dynamicSections.map((section) => renderDynamicSection(section))}

      {/* Supplier Screening Comments Section - Indented */}
      <div className="tcs-indented-section">
        <div className="tcs-comments-section">
          <table className="tcs-comments-table">
            <tbody>
              <tr>
                <td>Supplier Screening Comments</td>
                <td>
                  <p style={{ margin: 0 }}>{supplier_comments || ''}</p>
                  <p style={{ margin: '12px 0 0 0' }}>{supplier_note || ''}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TCSResumePreview;

